import { faBriefcaseMedical, faFileInvoice, faHospital, faListCheck, faPowerOff, faUser, faUserGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import AuthController from "../../apis/Controllers/AuthController/AuthController";
import { Drawer_profile, LeftIcon, Man } from "../../assets/images";
import { connect } from "react-redux";
import store from "../../redux/store";
import { setDrawer } from "../../redux/actions/users";
import { useLocation } from "react-router-dom";
import { renderImage } from "./General";


const DrawerComponent = (props) => {

    const [drawerState, setDrawerState] = useState()
    const [user, setUser] = useState(null)

    const location = useLocation();

    useEffect(() => {
        getUser();
    }, [location]);

    const getUser = async () => {
        let response = await AuthController.getLoginUser();
        if (response) {
            setUser(response);
        } else {
            setUser(null);
        }

    };

    let drawerMenu = [
        {
            name: 'Dashboard',
            path: user && user.user_type === 2 ? '/dashboard' : '/dashboard-superadmin',
            icon: faHospital,
            active: false
        },
        {
            name: 'Manage Hospitals',
            path: '/hospital-listing',
            icon: faBriefcaseMedical,
            active: false
        },
        {
            name: 'Manage Staff',
            path: '/staff-list',
            icon: faUserGroup,
            active: false
        },
        // {
        //     name: 'Manage Patient',
        //     path: '/manage-patient-list',
        //     icon: faUser,
        //     active: false
        // },
        {
            name: 'Manage Tasks',
            path: '/task-list',
            icon: faListCheck,
            active: false
        },
        {
            name: 'Manage Roles',
            path: '/role-list',
            icon: faFileInvoice,
            active: false
        },
        {
            name: 'Manage Ward',
            path: '/wards',
            icon: faFileInvoice,
            active: false
        },
        {
            name: 'Manage Department',
            path: '/department',
            icon: faFileInvoice,
            active: false
        },
        // {
        //     name: 'Change Password',
        //     path: '/change-password',
        //     icon: faLock,
        //     active: false
        // },
    ]

    const [drawerList, setDrawerList] = useState(drawerMenu)

    useEffect(() => {
        var x = window.matchMedia("(max-width: 700px)")
        setDrawerState(x)
    }, []);

    useEffect(() => {
        if (props.drawerState) {
            openNav()
        } else {
            closeNav()
        }

    }, [props.drawerState]);

    const openNav = () => {
        document.getElementById("mySidenav").style.width = drawerState.matches ? "100%" : "450px";
    };

    const closeNav = () => {
        document.getElementById("mySidenav").style.width = "0";
    };

    const handleDrawer = async (e) => {
        await store.dispatch(setDrawer(false));
    }

    return (
        <>
            <div id="mySidenav" className="sidenav">
                <div className="header_area">
                    <div className="icon_top" onClick={handleDrawer} >
                        <a href="javascript:;">  <Image src={LeftIcon} alt="..." /></a>
                    </div>
                    <div className="profile_info">
                        <div className="img_area">
                            <Image src={user && user.image ? renderImage(user.image) : Man} alt="..." />
                        </div>
                        <h5>{user && user.name ? user.name : ""}</h5>
                        <p>{user && user.role_title ? user.role_title : "Super Admin"}</p>
                    </div>
                </div>
                <div className="body_area">
                    <div className="content_area">
                        <div className="left_area">
                            <p>Oxford Hospital</p>
                        </div>
                        <div className="right_area">
                            <a href="javascript:;" className="btn btn-primary">Change</a>
                        </div>
                    </div>
                    <div className="list_area">
                        <ul>
                            {drawerList.map((item, index) => (
                                <li key={index} className={location.pathname === item.path ? "active" : ""}>
                                    <a href={item.path}>
                                        <div className="text_icon_area">
                                            <div className="left_icon">
                                                <div className="icon_box">
                                                    <FontAwesomeIcon icon={item.icon} />
                                                </div>
                                            </div>
                                            <div className="right_text">
                                                <p>{item.name}</p>
                                            </div>
                                        </div>
                                    </a></li>
                            ))}
                            <li><a href="javascript:;" onClick={() => AuthController.logout()}>
                                <div className="text_icon_area">
                                    <div className="left_icon">
                                        <div className="icon_box">
                                            <FontAwesomeIcon icon={faPowerOff} />
                                        </div>
                                    </div>
                                    <div className="right_text">
                                        <p onClick={() => AuthController.logout()}>Log Out</p>
                                    </div>
                                </div>
                            </a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    drawerState: state.DrawerReducer.drawerState,
});
export default connect(mapStateToProps)(DrawerComponent);